import { ObjectCreationValidatorError } from '@/entities/errors/validator_errors/ObjectCreationValidatorError'
import { ObjectCreationValidatorI } from '@/typescript/types/abstracts/validations/ValidateModuleTypes'
export default class ObjectCreationValidator implements ObjectCreationValidatorI {
  static validate<T extends object>(object: T) {
    Object.keys(object).forEach(propertyName => {
      const objectValue = object[propertyName as keyof T]
      if (typeof objectValue === 'undefined') {
        const error = new ObjectCreationValidatorError({
          message: `Object "${object.constructor.name}" can't create because the property "${propertyName}" is undefined!`,
          name: 'ObjectCreationValidatorError',
        })
        console.error('ObjectCreationValidator failed: ', error)
        throw error
      }
    })
  }
}
